import type { FirebaseOptions } from "firebase/app";

const {
  VITE_LOG_LEVEL,
  VITE_KANPLA_API_URL,
  VITE_WEB_DEVICE_ID,
  VITE_WEB_TILL_ID,
  VITE_PWA_ENV,
  VITE_SENTRY_SAMPLES_RATE,
  VITE_INTERCOM_APP_ID,
  VITE_UNLEASH_FRONTEND_API_TOKEN,
  VITE_UNLEASH_ENVIRONMENT,
  VITE_UNLEASH_FRONTEND_API_URL,
  VITE_FIREBASE_CONFIG
} = import.meta.env;

const PWA_ENVIRONMENTS = ["production", "staging", "preview", "development"];

if (!VITE_KANPLA_API_URL || typeof VITE_KANPLA_API_URL !== "string") {
  throw new Error("VITE_KANPLA_API_URL missing in env vars");
}

if (!VITE_WEB_DEVICE_ID || typeof VITE_WEB_DEVICE_ID !== "string") {
  throw new Error("VITE_WEB_DEVICE_ID missing in env vars");
}

if (!VITE_WEB_TILL_ID || typeof VITE_WEB_TILL_ID !== "string") {
  throw new Error("VITE_WEB_TILL_ID missing in env vars");
}

if (!VITE_PWA_ENV || typeof VITE_PWA_ENV !== "string") {
  throw new Error("VITE_PWA_ENV missing in env vars");
}

if (!PWA_ENVIRONMENTS.includes(VITE_PWA_ENV)) {
  // Validate, don't coerce: an off-list token is a source misconfiguration we surface.
  // eslint-disable-next-line no-console -- intentional misconfiguration warning
  console.warn(
    `Unexpected VITE_PWA_ENV "${VITE_PWA_ENV}"; expected one of ${PWA_ENVIRONMENTS.join(
      ", "
    )}.`
  );
}

if (
  !VITE_UNLEASH_FRONTEND_API_TOKEN ||
  !VITE_UNLEASH_ENVIRONMENT ||
  !VITE_UNLEASH_FRONTEND_API_URL
) {
  throw new Error("UNLEASH config variables missing in env vars");
}

if (!VITE_FIREBASE_CONFIG || typeof VITE_FIREBASE_CONFIG !== "string") {
  throw new Error("VITE_FIREBASE_CONFIG missing in env vars");
}

let parsedFirebaseConfig: FirebaseOptions;
try {
  parsedFirebaseConfig = JSON.parse(VITE_FIREBASE_CONFIG) as FirebaseOptions;
} catch (error) {
  throw new Error(`Failed to parse VITE_FIREBASE_CONFIG: ${String(error)}`);
}

if (
  !parsedFirebaseConfig.apiKey ||
  !parsedFirebaseConfig.authDomain ||
  !parsedFirebaseConfig.projectId
) {
  throw new Error(
    "VITE_FIREBASE_CONFIG must include apiKey, authDomain and projectId"
  );
}

const KANPLA_API_URL = VITE_KANPLA_API_URL;
const PWA_ENV = VITE_PWA_ENV;
const parsedSamplesRate = Number(VITE_SENTRY_SAMPLES_RATE);
// Fall back to 0.1 on an unset/invalid/out-of-range value so a misconfigured
// sample rate can't disable or blow up tracing.
const SENTRY_SAMPLES_RATE =
  Number.isFinite(parsedSamplesRate) &&
  parsedSamplesRate >= 0 &&
  parsedSamplesRate <= 1
    ? parsedSamplesRate
    : 0.1;
const INTERCOM_APP_ID = VITE_INTERCOM_APP_ID;
const LOG_LEVEL = VITE_LOG_LEVEL;
const UNLEASH_FRONTEND_API_TOKEN = VITE_UNLEASH_FRONTEND_API_TOKEN;
const UNLEASH_ENVIRONMENT = VITE_UNLEASH_ENVIRONMENT;
const UNLEASH_FRONTEND_API_URL = VITE_UNLEASH_FRONTEND_API_URL;
const FIREBASE_CONFIG = parsedFirebaseConfig;

export {
  KANPLA_API_URL,
  PWA_ENV,
  SENTRY_SAMPLES_RATE,
  INTERCOM_APP_ID,
  LOG_LEVEL,
  UNLEASH_FRONTEND_API_TOKEN,
  UNLEASH_ENVIRONMENT,
  UNLEASH_FRONTEND_API_URL,
  FIREBASE_CONFIG
};
